module.exports = __webpack_public_path__ + "img/132.aa4871fc.jpg";